import type { StepType } from '@reactour/tour';
import type { TourStepContext } from './types';

export const portfolioAiSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="portfolio-ai-generate-btn"]',
    content:
      'Clique aqui para abrir o painel de Relatório IA de Portfólio. Você pode gerar uma nova análise ou visualizar relatórios anteriores.',
  },
  {
    selector: '[data-tour="portfolio-ai-stat-total"]',
    content:
      'Este painel mostra o total de relatórios de portfólio já gerados para o tenant selecionado.',
  },
  {
    selector: '[data-tour="portfolio-ai-history"]',
    content:
      'Aqui fica o histórico de relatórios. Clique em qualquer linha para abrir e visualizar o relatório detalhado ou fazer download em PDF.',
  },
];
